import {Skeleton} from '@dropbox/dig-components/skeleton';
import {Box} from '@dropbox/dig-foundations';

import styles from './ProductRoadmap.module.css';

export const RoadmapEmbedLoadingFrame = () => (
  <Box className={styles.productRoadmapEmbedLoadingFrame} aria-hidden="true">
    <Skeleton.Box height={48} withBorderRadius="medium" />
    <Skeleton.Box height={48} withBorderRadius="medium" />
    <Skeleton.Box height={48} withBorderRadius="medium" />
  </Box>
);
